import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useSetCurrentModalValue } from '../../../../../../../../Components/Modal';
import Accounts, { useAccountDocumentArDocModalName } from '../../../../../accounts';
import { FileIconModalButtonContainer } from './container';
import { ArDocFileIcon } from '../../fileIcon';

export const AccountDocumentsFileIconModalButton = (props: {
  hasFileName?: boolean,
  size?: string | number | undefined,
  transform?: ouiStyle.InStyle['transform'],
  stroke?: ouiStyle.Constants.Colors,
}) => {
  const {
    hasFileName,
    transform,
    size,
    stroke,
  } = props;
  const {
    data,
  } = useAccountDocumentArDocModalName();
  const onClick = useSetCurrentModalValue(data ?? null, !hasFileName);
  return (
    <FileIconModalButtonContainer
      onClick={onClick}
      hasFileName={hasFileName}
      transform={transform}
    >
      <ArDocFileIcon
        service={Accounts.Documents}
        size={size}
        stroke={stroke}
      />
    </FileIconModalButtonContainer>
  );
};
